import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function getScoreVariant(score) {
    if (score <= 40)
        return "cold";
    if (score >= 71)
        return "hot";
    return "warm";
}
const LABELS = {
    cold: "Frío",
    warm: "Tibio",
    hot: "Caliente",
};
const SIZE_CLASSES = {
    xs: "text-[10px] px-2 py-0.5",
    sm: "text-[11px] px-2 py-0.5",
    md: "text-[13px] px-2.5 py-1",
    lg: "text-[15px] px-3 py-1",
};
const VARIANT_CLASSES = {
    cold: "bg-score-cold-bg text-score-cold-fg",
    warm: "bg-score-warm-bg text-score-warm-fg",
    hot: "bg-score-hot-bg text-score-hot-fg",
};
export function ScoreBadge({ score, size = "md", showLabel = true, className = "", }) {
    const variant = getScoreVariant(score);
    return (_jsxs("span", { className: `inline-flex items-center gap-1.5 rounded-full font-semibold ${SIZE_CLASSES[size]} ${VARIANT_CLASSES[variant]} ${className}`, children: [_jsx("span", { className: "rounded-full w-1.5 h-1.5 bg-current opacity-70" }), score, showLabel && _jsx("span", { className: "opacity-75", children: LABELS[variant] })] }));
}
//# sourceMappingURL=ScoreBadge.js.map